import { DefineGetters } from "vuex-type-helper";
import { QuickPayGetters, QuickPayState } from "./types";

export const getters: DefineGetters<QuickPayGetters, QuickPayState> = {};
